import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { getCategoryBySlug } from "@/mocks/categories";
import { formatDate, formatNumber } from "@/lib/content";

export default function FeaturedPicks() {
  const lead = articles[0];
  const leadCategory = getCategoryBySlug(lead.categorySlug);
  const side = [articles[1], articles[2], articles[3], articles[6]];

  return (
    <section className="bg-background-100 border-b border-background-200">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <article className="lg:col-span-6 group">
            <Link to={`/article/${lead.id}`} className="block w-full aspect-[16/11] rounded-lg overflow-hidden bg-background-200">
              <img
                src={lead.cover}
                alt={lead.coverAlt}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </Link>
            <div className="pt-5">
              <div className="flex items-center gap-2">
                <span className="inline-flex items-center px-2.5 py-1 rounded-full text-[11px] bg-primary-500 text-background-50">
                  今日首选
                </span>
                <span className="text-xs text-foreground-600">{leadCategory?.name}</span>
              </div>
              <h3 className="mt-3 font-heading text-xl md:text-2xl leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors">
                <Link to={`/article/${lead.id}`}>{lead.title}</Link>
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 line-clamp-2">{lead.excerpt}</p>
              <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                <span>{lead.author}</span>
                <span>{formatDate(lead.date)}</span>
                <span className="flex items-center gap-1"><i className="ri-time-line"></i>{lead.readTime}</span>
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{formatNumber(lead.views)}</span>
              </div>
            </div>
          </article>

          <div className="lg:col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-7">
            {side.map((item) => {
              const cat = getCategoryBySlug(item.categorySlug);
              return (
                <article key={item.id} className="group flex flex-col">
                  <Link to={`/article/${item.id}`} className="block w-full aspect-[16/10] rounded-lg overflow-hidden bg-background-200">
                    <img
                      src={item.cover}
                      alt={item.coverAlt}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </Link>
                  <div className="pt-3.5 flex flex-col flex-1">
                    <span className="text-[11px] text-foreground-500">{cat?.name}</span>
                    <h3 className="mt-1.5 text-sm md:text-base font-medium leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors">
                      <Link to={`/article/${item.id}`} className="line-clamp-2">{item.title}</Link>
                    </h3>
                    <p className="mt-auto pt-3 text-xs text-foreground-500 flex items-center gap-3">
                      <span>{formatDate(item.date)}</span>
                      <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{formatNumber(item.views)}</span>
                    </p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}